import {useStompClient, useSubscription} from "react-stomp-hooks";
import React, {useEffect, useState} from "react";
import {StompHeaders} from "@stomp/stompjs";
import {useKeycloak} from "@react-keycloak/web";
import {ParticipantStatus} from "../../../enums/ParticipantStatus";
import {GoogleMap, Marker, useJsApiLoader} from '@react-google-maps/api';
import {Button, Popover, Tooltip} from "antd";
import {AimOutlined, CloseOutlined} from "@ant-design/icons";
import jobApiService from "../../../service/jobApiService";

const containerStyle = {
    width: '400px',
    height: '400px'
};


export interface Center {
    lat: any,
    lng: any
}

export default function GoogleMapView({username, participantConnectingStatus}: {
    username: string,
    participantConnectingStatus: ParticipantStatus
}) {


    return (<SubscribingComponent username={username}
                                  participantConnectingStatus={participantConnectingStatus} />);
}

const SubscribingComponent: React.FC<{
    username: string,
    participantConnectingStatus: string,
}> = ({username, participantConnectingStatus}) => {
    const [participantConnected, setParticipantConnected] = useState<boolean>(false);
    const [center, setCenter] = useState<Center>({lat: 0, lng: 0});

    const [open, setOpen] = useState(false);

    const hide = () => {
        setOpen(false);
    };
    const {keycloak} = useKeycloak();
    let stompHeaders: StompHeaders = {
        "accessToken": keycloak.token ? keycloak.token : "",
        "username": username
    }

    const {isLoaded} = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: process.env.GOOGLE_MAP_API_KEY ? process.env.GOOGLE_MAP_API_KEY : ""
    });

    const [map, setMap] = React.useState<any>(null)
    const onLoad = React.useCallback(function callback(map: any) {
        const bounds = new window.google.maps.LatLngBounds(center);
        map.fitBounds(bounds);

        setMap(map)
    }, [])

    const onUnmount = React.useCallback(function callback(map: any) {
        setMap(null)
    }, [])


    useEffect(() => {
        if (participantConnectingStatus == ParticipantStatus.PARTICIPANT_CONNECTED) {
            setParticipantConnected(true);
        } else {
            setParticipantConnected(false);
        }
    }, [participantConnectingStatus]);

    const handleOpenChange = (newOpen: boolean) => {
        setOpen(newOpen)
        if (newOpen) {
            jobApiService.getJobDetailDtoByLocalUserAccessToken(username).then(res => {
                let callDetail = res.data.results.callDetailsDtoList[0];
                setCenter({lat: parseFloat(callDetail.latitude), lng: parseFloat(callDetail.longitude)});
            })
        }

    };
    const stompClient = useStompClient();

    useSubscription("/user/topic/send-geolocation-details-response", (message) => {
        let res: any = JSON.parse(message.body);
        stompClient?.publish({
            destination: `/video/app/acknowledge`,
            body: message.headers.messageId
        });
        console.log(`send-geolocation-details-response Acknowledgment sent for message: ${message.headers.messageId}`);

        setCenter({lat: parseFloat(res.latitude), lng: parseFloat(res.longitude)});

    }, stompHeaders);
    return <>
        {
            participantConnected ? <Tooltip title="Track Location">
                    <Popover
                        onOpenChange={handleOpenChange}
                        open={open}
                        content={
                            <div style={{
                                maxWidth: '100%',
                                listStyle: 'none',
                                transition: 'none',
                                overflow: 'hidden',
                                width: '400px',
                                height: '400px'
                            }}>
                                <Tooltip title="MAP">
                                    {
                                        isLoaded && participantConnected ? (
                                            <GoogleMap
                                                mapContainerStyle={containerStyle}
                                                center={center}
                                                zoom={10}
                                                onLoad={onLoad}
                                                onUnmount={onUnmount}
                                            >
                                                <Marker position={{lat: center.lat, lng: center.lng}}/>
                                                <></>
                                            </GoogleMap>
                                        ) : <></>
                                    }
                                </Tooltip>
                            </div>

                        }
                        title={<div className={"popover_close_btn"}>Map <span> <Button onClick={hide}
                                                                                       type="text"><CloseOutlined/>

    </Button></span></div>}
                        trigger="click">
                        <Button type="primary" style={{backgroundColor: '#36910a'}} shape="circle"
                                icon={<AimOutlined/>} size={"large"}/>
                    </Popover>
                </Tooltip>

                : <><Button type="primary" style={{backgroundColor: '#cecccc'}} shape="circle" disabled
                            icon={<AimOutlined/>} size={"large"}/></>
        }
        <></>
    </>
}
